import _extends from '@babel/runtime-corejs3/helpers/extends';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import React__default from 'react';
import classNames from 'classnames';
import styles from './6a1730b3ccdac247d1302687b3baef89aa687eea30d4790fa0ca07fc91e85df0.cfe-internal.js';

var _excluded = ["background", "children", "className", "inverted", "show", "size", "role", "aria-label", "aria-live", "aria-hidden"];
var LoadingSpinner = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var _classNames2, _classNames3;

  var _ref$background = _ref.background,
      background = _ref$background === void 0 ? 'fade' : _ref$background,
      children = _ref.children,
      className = _ref.className,
      _ref$inverted = _ref.inverted,
      inverted = _ref$inverted === void 0 ? false : _ref$inverted,
      _ref$show = _ref.show,
      show = _ref$show === void 0 ? false : _ref$show,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      _ref$role = _ref.role,
      role = _ref$role === void 0 ? 'progressbar' : _ref$role,
      ariaLabel = _ref['aria-label'],
      _ref$ariaLive = _ref['aria-live'],
      ariaLive = _ref$ariaLive === void 0 ? 'polite' : _ref$ariaLive,
      ariaHidden = _ref['aria-hidden'],
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React__default.createElement("div", _extends({}, rest, {
    ref: ref,
    className: classNames(className, styles.spinnerContainer, _defineProperty({}, styles[size], !children))
  }), /*#__PURE__*/React__default.createElement("div", {
    className: classNames(styles.spinnerComponent, styles[size], (_classNames2 = {}, _defineProperty(_classNames2, styles.inverted, inverted), _defineProperty(_classNames2, styles.hide, !show), _classNames2)),
    "data-loadingspinner": show || undefined,
    role: role,
    "aria-label": ariaLabel,
    "aria-live": ariaLive,
    "aria-hidden": ariaHidden
  }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", null), /*#__PURE__*/React__default.createElement("div", null), /*#__PURE__*/React__default.createElement("div", null), /*#__PURE__*/React__default.createElement("div", null), /*#__PURE__*/React__default.createElement("div", null), /*#__PURE__*/React__default.createElement("div", null), /*#__PURE__*/React__default.createElement("div", null), /*#__PURE__*/React__default.createElement("div", null), /*#__PURE__*/React__default.createElement("div", null))), /*#__PURE__*/React__default.createElement("div", {
    className: classNames(styles.spinnerContent, (_classNames3 = {}, _defineProperty(_classNames3, styles[background], show), _defineProperty(_classNames3, styles.disablePointerEvents, show), _classNames3))
  }, children));
});
var LoadingSpinner$1 = LoadingSpinner;

export { LoadingSpinner$1 as default };
